(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cn-ebay-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cn-ebay-carousel')) {
  customElements.define('cn-ebay-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-cn-slide]')];
      if (this.slides.length < 2) return;
      this.current = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.visible = false;
      this.hovered = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.toggle = this.querySelector('[data-cn-toggle]');
      this.stage = this.querySelector('.cn-feedback-stage');
      this.setAttribute('data-ready', '');
      this.querySelector('.cn-feedback-controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-cn-toggle')) {
          this.paused = !this.paused;
          this.sync();
          return;
        }
        let next;
        if (button.hasAttribute('data-cn-select')) next = Number(button.dataset.cnSelect);
        if (button.hasAttribute('data-cn-prev')) next = this.current - 1;
        if (button.hasAttribute('data-cn-next')) next = this.current + 1;
        if (next !== undefined) { this.paused = true; this.show(next); this.sync(); }
      }, options);
      this.addEventListener('focusin', event => {
        if (event.target !== this.toggle) { this.paused = true; this.sync(); }
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.sync(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-cn-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) { this.paused = true; this.show(index); this.sync(); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.25 });
      this.observer.observe(this);
      this.sync();
    }
    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== this.current));
        slide.inert = i !== this.current;
      });
      this.querySelectorAll('[data-cn-select]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.current)));
    }
    sync() {
      clearInterval(this.timer);
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.stage.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      if (!this.paused && !this.hovered && this.visible && !document.hidden) this.timer = setInterval(() => this.show(this.current + 1), 10000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-hero-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cn-hero-carousel')) {
  customElements.define('cn-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cn-hero-track');
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-hero-thumb]')];
      if (this.slides.length < 2) return;
      this.current = 0;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.querySelector('.cn-hero-switcher').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-hero-prev')) this.go(this.current - 1);
        else if (button.hasAttribute('data-hero-next')) this.go(this.current + 1);
        else if (button.hasAttribute('data-hero-thumb')) this.go(this.thumbs.indexOf(button));
      }, options);
      this.querySelector('.cn-hero-thumbs').addEventListener('keydown', event => {
        const keys = ['ArrowLeft','ArrowRight','Home','End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        let next = this.current + (event.key === 'ArrowLeft' ? -1 : 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.slides.length - 1;
        next = Math.max(0,Math.min(this.slides.length-1,next));
        this.thumbs[next].focus(); this.go(next);
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => {
          const box = this.track.getBoundingClientRect();
          const closest = this.slides.map(slide => Math.abs(slide.getBoundingClientRect().left-box.left));
          this.current = closest.indexOf(Math.min(...closest)); this.update();
        }, 100);
      }, {...options,passive:true});
      this.resize = new ResizeObserver(() => this.go(this.current, true));
      this.resize.observe(this.track);
      this.update();
    }
    go(index, instant = false) {
      this.current = Math.max(0,Math.min(this.slides.length-1,index));
      const offset = this.slides[this.current].getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft;
      this.track.scrollTo({left:offset,behavior:instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.update();
    }
    update() {
      this.thumbs.forEach((button,i) => button.setAttribute('aria-pressed',String(i===this.current)));
      this.slides.forEach((slide,i) => {slide.inert=i!==this.current;slide.setAttribute('aria-hidden',String(i!==this.current));});
      this.querySelector('[data-hero-prev]').disabled=this.current===0;
      this.querySelector('[data-hero-next]').disabled=this.current===this.slides.length-1;
      this.querySelector('[data-hero-count]').textContent=`${this.current+1} / ${this.slides.length}`;
    }
    disconnectedCallback() {clearTimeout(this.settle);this.abort?.abort();this.resize?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
const setup = () => {
document.querySelectorAll('.cn-region').forEach(region => {
 if(region.dataset.ready)return; region.dataset.ready='true';region.addEventListener('toggle',()=>{if(region.open)region.style.setProperty('--cn-region-top',Math.min(region.querySelector('summary').getBoundingClientRect().bottom+8,window.innerHeight*.3)+'px');});
 region.addEventListener('keydown',event=>{if(event.key==='Escape'){region.open=false;region.querySelector('summary').focus();}});
 document.addEventListener('pointerdown',event=>{if(!region.contains(event.target))region.open=false;});
});
const info=document.querySelector('product-info .product__info-container');
const bar=document.querySelector('.cn-purchase-bar');
if(!info||!bar||bar.dataset.ready)return;
bar.dataset.ready='true';
const picker=info.querySelector('variant-selects')||info.querySelector('.product-form__quantity')||info;
const anchor=document.createElement('span');anchor.id='CnPurchaseOptions';picker.before(anchor);
const buy=info.querySelector('button[name="add"]');
const trust=document.getElementById('CnPurchaseTrust');
if(buy&&trust)buy.closest('product-form').after(trust);
const update=()=>{
const current=info.querySelector('[id^="price-"] .price__regular .price-item--regular');
const sale=info.querySelector('[id^="price-"] .price--on-sale .price-item--sale');
if(sale||current){const value=(sale||current).textContent.trim();const target=bar.querySelector('[data-cn-sticky-price]');if(target.textContent!==value)target.textContent=value;}
const button=info.querySelector('button[name="add"]');
if(button){const rect=button.getBoundingClientRect();bar.hidden=rect.top<window.innerHeight&&rect.bottom>0;}
};
bar.querySelector('a').addEventListener('click',event=>{event.preventDefault();picker.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});const control=picker.querySelector('input,select,button');if(control)control.focus({preventScroll:true});});
info.addEventListener('change',()=>{setTimeout(update,500);setTimeout(update,1500);});
window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-site-polish"] && !Shopify.designMode) return;
  try {
    (() => {
const mountSearch = () => {
const root = document.getElementById('cn-search');
const header = document.querySelector('header.cn-nav, header.cc-nav, header.cp-nav, header.cs-nav');
if (!root || !header || root.dataset.mounted) return;
root.dataset.mounted = 'true'; header.after(root); root.classList.add('cn-search-mounted');
const toggle = document.getElementById('CnSearchToggle').content.firstElementChild.cloneNode(true); header.insertBefore(toggle, header.lastElementChild);
const input = root.querySelector('input[type="search"]');
const panel = root.querySelector('.cn-search-panel'); const list = root.querySelector('.cn-search-items'); const status = root.querySelector('[role="status"]');
let timer, controller, generation = 0;
const close = () => { panel.hidden = true; };
toggle.addEventListener('click', () => {const open = root.classList.toggle('cn-search-open'); toggle.setAttribute('aria-expanded', String(open)); if (open) input.focus(); else close();});
const search = async () => {
const term = input.value.trim(); const current = ++generation;
if (controller) controller.abort(); list.replaceChildren();
if (term.length < 2) {status.textContent = ''; close(); return;}
panel.hidden = false; status.textContent = root.dataset.loading; controller = new AbortController();
try {
const url = new URL(root.dataset.endpoint, window.location.origin);
url.search = new URLSearchParams({q:term,'resources[type]':'product','resources[limit]':'5','resources[options][fields]':'title,product_type,variants.title,variants.sku,vendor','section_id':'predictive-search'});
const response = await fetch(url, {signal:controller.signal}); if (!response.ok) throw new Error('Search response');
const html = new DOMParser().parseFromString(await response.text(), 'text/html'); if (current !== generation) return;
const rows = html.querySelectorAll('[id^="predictive-search-option-product-"]');
rows.forEach(row => {
const source = row.querySelector('a'); if (!source) return;
const item = document.createElement('li'); const link = document.createElement('a'); link.href = source.getAttribute('href');
const photo = row.querySelector('img'); if (photo) {const img = document.createElement('img'); img.src = photo.getAttribute('src'); img.alt = ''; img.width = 64; img.height = 72; link.append(img);}
const text = document.createElement('div'); const title = document.createElement('strong'); title.textContent = row.querySelector('.predictive-search__item-heading')?.textContent.trim() || source.textContent.trim(); text.append(title);
const amount = row.querySelector('[data-cn-search-price]'); if (amount) {const price = document.createElement('small'); price.textContent = amount.textContent.trim(); text.append(price);}
link.append(text); item.append(link); list.append(item);
});
status.textContent = rows.length ? '' : root.dataset.empty.replace('__QUERY__',term);
} catch(error) {if (error.name !== 'AbortError' && current === generation) {status.textContent = ''; list.replaceChildren();}}
};
input.addEventListener('input', () => {clearTimeout(timer); generation++; if (controller) controller.abort(); close(); timer = setTimeout(search, 250);});
input.addEventListener('focus', () => {if (input.value.trim().length > 1) search();});
root.addEventListener('keydown', event => {
if (event.key === 'Escape') {clearTimeout(timer); generation++; controller?.abort(); close(); if (window.matchMedia('(max-width:749px)').matches) {root.classList.remove('cn-search-open'); toggle.setAttribute('aria-expanded','false'); toggle.focus();} else input.focus(); event.preventDefault();}
if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {const links = [...list.querySelectorAll('a')]; if (panel.hidden || !links.length) return; const index = links.indexOf(document.activeElement); const next = event.key === 'ArrowDown' ? (index + 1) % links.length : (index <= 0 ? links.length - 1 : index - 1); links[next].focus(); event.preventDefault();}
});
document.addEventListener('pointerdown',event => {if (!root.contains(event.target) && !toggle.contains(event.target)) {clearTimeout(timer);generation++;controller?.abort();close();}});
root.addEventListener('focusout',event => {if (!root.contains(event.relatedTarget)) close();});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mountSearch); else mountSearch(); document.addEventListener('shopify:section:load',mountSearch);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-spec-filters"] && !Shopify.designMode) return;
  try {
    const cnInitFilters=root=>root.querySelectorAll('[data-cn-spec-filter]').forEach(form=>{
if(form.dataset.ready)return;form.dataset.ready='true';
const bands=['cn-room-0-6','cn-room-6-10','cn-room-10-15','cn-room-15-plus'];
const original=(form.dataset.currentTags||'').split('+').filter(Boolean);
const exact=original.find(tag=>/^\d+(?:-\d+)?-kw$/.test(tag));
if(exact&&!original.some(tag=>bands.includes(tag))){const n=Number(exact.replace(/-kw$/,'').replace('-','.'));form.querySelector('[data-cn-band]').value=bands[n<=6?0:n<=10?1:n<=15?2:3];}
form.addEventListener('submit',event=>{
event.preventDefault();
const tags=original.filter(tag=>!bands.includes(tag)&&!/^\d+(?:-\d+)?-kw$/.test(tag)&&!/^flue-\d+-mm$/.test(tag));
form.querySelectorAll('select').forEach(select=>{if(select.value)tags.push(select.value);});
const url=new URL(form.dataset.collectionUrl,location.origin);if(tags.length)url.pathname+='/'+[...new Set(tags)].join('+');
url.search=location.search;url.searchParams.delete('page');location.assign(url.href);
});
});
cnInitFilters(document);document.addEventListener('shopify:section:load',event=>cnInitFilters(event.target));
  } catch(e) { console.error(e); }
})();

})();
